export const getHumanDuration = (duration: number, withDescription?: boolean) => {
    const totalSeconds = duration / 1000

    const seconds = Math.floor(totalSeconds % 60)
    const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds.toString()
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const description =
        withDescription === true
            ? totalSeconds >= 3600
                ? ' hours'
                : minutes > 0
                ? ' mins'
                : ' seconds'
            : ''

    if (totalSeconds >= 3600) {
        const hours = Math.floor(totalSeconds / 3600)
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes.toString()

        return `${hours}:${formattedMinutes}:${formattedSeconds}${description}`
    }

    return `${minutes}:${formattedSeconds}${description}`
}
